export const IS_TEST = process.env.NODE_ENV === 'test';
//产品类型
export const PRODUCT_TYPE = {
    'route': '路由器',
    'mesh': '免布线',
    'ap': 'AP',
    'ac': 'AC',
    'switch': '交换机',
    'v7': '微企',
    'wireroute': '无线路由',
    'cpe': '网桥',
    'extend': '扩展器',
}
//数据校验级别
export const CHECHLEVEL = {
    1: '免校验',
    2: '弱校验',
    3: '强校验',
}
//网关类型
export const LINKTYPE = {
    'direct_link': '直连',
    'gateway': '网关',
    'sub_dev': '网关子设备',
}
//策略类型
export const STRATEGY_TYPE = {
    'base-sn': '基于设备KEY',
    'base-mac': '基于设备KEY和MAC',
}
//设备类型
export const LANGUAGE = {
    'zh-Hans': '中文简体',
    'zh-Hant': '中文繁体',
    'en': '英文',
    'uk': '乌克兰语',
    'ru': '俄罗斯语',
    'de': '德语',
    'pl': '波兰',
    'pt-BR': '巴西葡语',
    'tr': '土耳其',
    'id': '印度尼西亚',
    'ko': '韩文',
    'it': '意大利',
    'es': '西班牙语',
}
//认证方式
export const AUTH_STYLE = {
    'machine': '一机一密',
    'model': '一型一密',
}
export const FUNCTION_TYPE = {
    'properties': '属性',
    'service': '服务',
    'event': '事件',
}
export const BASE_TOPIC_TYPE = {
    'broadcast': '广播',
    'sys': '系统',
    'ota': '升级',
    'diy': '自定义',
    'trans': '转发',
    'subscribe': '订阅'
}
export const PUB_SUB = {
    'pub': '发布',
    'sub': '订阅',
}
export const ONLINE_TYPE = {
    'online': '在线',
    'offline': '离线',
}
export const RULE_TYPE = {
    'MQTT': 'MQTT',
    'TOPIC': 'TOPIC',
    'INTERFACE': '接口',
    'MQ': '消息队列',
}